(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-result/assets/javascripts/api-calls/result.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-result/assets/javascripts/api-calls/result.js');

'use strict';

const {
  API_PATHS
} = svs.lyckoplatsen.components.shared_constants;
const jupiter = svs.core.jupiter;
async function fetchResult(product, drawNumber) {
  try {
    const {
      response
    } = await jupiter.callAsync({
      path: API_PATHS.resultByDrawId(product, drawNumber),
      method: 'GET'
    });
    return response.result;
  } catch (e) {
    svs.lyckoplatsen.logger.info('Failed to get result', e);
  }
}
Object.assign(svs.lyckoplatsen.components.shared_result.api_calls, {
  fetchResult
});

 })(window);